import { FaComments, FaArrowRight } from 'react-icons/fa';
import { CONTACT } from '../constants/contact';
import { openZohoChat } from '../utils/openZohoChat';
import './CTABanner.css';

export default function CTABanner() {
  return (
    <section className="dh-cta" id="contact">
      <div className="dh-container">
        <div className="dh-cta__box">
          <h2>Haven&apos;t found what you&apos;re looking for?</h2>
          <div className="dh-cta__actions">
            <button type="button" className="dh-btn dh-btn--blue" onClick={openZohoChat}>
              <FaComments aria-hidden /> Chat With Tech
            </button>
            <a href={`mailto:${CONTACT.email}`} className="dh-btn dh-btn--ghost">
              Contact Us <FaArrowRight aria-hidden />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
